import React from 'react';
import { Link } from 'react-router-dom';
import { getCurrency, toggleOptionsMenu } from '../../Helper';

function FeePaymentTable(props) {

    const tableBody = props.feePayments.map(fp => {
        const viewFeeURL = '/admin/fees/' + fp.feeID;
        const viewAccountURL = '/admin/accounts/' + (fp.fee?.accountID ?? null);

        return (
            <tr key={fp.paymentID + '|' + fp.feeID}>
                <td>
                    <span>{fp.fee?.account?.accountNumber ?? null}</span>
                </td>
                <td>
                    <span>{fp.fee?.account?.name ?? null}</span>
                </td>
                <td>
                    <span>{fp.fee?.facility ?? null}</span>
                </td>
                <td>
                    <span>{fp.fee?.identifier ?? null}</span>
                </td>
                <td>
                    <span>{getCurrency(fp.paymentAmount)}</span>
                </td>
                <td>
                    <div className="actions">
                        <div onClick={toggleOptionsMenu} className="action-icon action-dropdown">
                            <i className="fas fa-ellipsis-h"></i>
                            <div className="action-dropdown-menu">
                                <Link className="action-dropdown-menu-item" to={viewFeeURL}><span>View Fee</span></Link>
                                <Link className="action-dropdown-menu-item" to={viewAccountURL}><span>View Account</span></Link>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        );
    });

    return (
        <table className="table">
            <thead>
                <tr>
                    <th>
                        <span>Account Number</span>
                    </th>
                    <th>
                        <span>Account</span>
                    </th>
                    <th>
                        <span>Facility</span>
                    </th>
                    <th>
                        <span>EPAID/Permit Number</span>
                    </th>
                    <th>
                        <span>Amount</span>
                    </th>
                    <th>
                    </th>
                </tr>
            </thead>
            <tbody>
                {tableBody}
            </tbody>
        </table>
    );
}

export default FeePaymentTable;